import React from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import {
  Modal,
} from 'web-components';

import Body from './Body';

const mapState = state => ({
  videos: coreSelectors.getVideos(
    'recent',
  )(state),
  searchStatus: getStatus(
    state,
    'videos.requests.searchVideos.status',
    true,
  ),
  requestMeta: coreSelectors.getRequestProperties(
    'videos',
    'searchVideos',
  )(state).meta,
  searchVideoModal: getUiState('searchVideoModal')(state),
});

type Props = {
  onRequestClose: { (): void };
};

const SearchVideoModal = ({ onRequestClose }: Props) => {
  const {
    videos,
    requestMeta,
    searchStatus,
    searchVideoModal,
  } = useSelector(mapState, shallowEqual);

  const {
    query,
    title,
    scope,
    isOpen,
    assignedId,
    assignedText,
    assignButton,
  } = searchVideoModal;

  return (
    <Modal
      title={title || 'Search Workout Video'}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Body
        initial={{
          scope,
          query,
        }}
        videos={videos}
        status={searchStatus}
        assignedId={assignedId}
        requestMeta={requestMeta}
        assignedText={assignedText}
        assignButton={assignButton}
      />
    </Modal>
  );
};

export default SearchVideoModal;
